import { DealsTable } from 'components/Tables/DealsTable/DealsTable'
import { DEAL_TABLE_KEY, getCampaignTableKey } from 'constants/tableQueryKeys'
import type { Campaign } from 'models/campaign'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'

interface Props {
  campaign: Campaign
}

/**
 * Deals tab on the campaign dashboard: the deals table scoped to deals that
 * originated from this campaign (origin_campaign). The table was dropped in
 * the DS2026 campaign-page redesign and replaced with a count-only
 * placeholder; this restores the legacy single-campaign-page wiring.
 *
 * Always renders the table rather than gating on campaign.deal_count: that
 * count is the async-refreshed agg_deal_count denormalization and can lag
 * the live deals query, which would hide real rows behind an empty state.
 */
export function CampaignDashboardDealsTab({ campaign }: Props) {
  const featureFlag = useFeatureFlagService()

  return (
    <DealsTable
      useReports={!featureFlag.enableCampaignDenormalizedStats}
      showCompanyColumn
      disableUrlPagination
      filterIdentifierModifier={`_CAMPAIGN_${campaign.id}`}
      defaultColumnVisibility={{ identifier: false }}
      baseFilters={{
        origin_campaign: campaign.id,
        ...(featureFlag.enableCampaignDenormalizedStats && {
          view_mode: 'campaign' as const,
        }),
      }}
      tableKey={getCampaignTableKey(DEAL_TABLE_KEY, campaign.id)}
    />
  )
}
